import { createFileRoute, Link } from '@tanstack/react-router';
import { useAuth } from '@/lib/auth/authContext';
import { useProperty } from '@/lib/property/propertyContextDef';
import { useBusinessListings } from '@/lib/data/settlement';
import { PageLoading } from '@/ui/Loader';
import { SeasonsPanel } from '@/lib/seasons/SeasonsPanel';

export const Route = createFileRoute('/rates/')({
  component: RatesListPage,
});

function RatesListPage() {
  const { supabase } = useAuth();
  const { businessId } = useProperty();
  const listingsQuery = useBusinessListings(supabase, businessId);

  return (
    <section className="flex flex-col gap-lg">
      <div>
        <h1 className="text-screen-title font-extrabold tracking-tight text-ink">Rates &amp; availability</h1>
        <p className="mt-sm text-body text-ink-2">Set seasons for several rooms at once, or pick a listing to set prices for single days.</p>
      </div>

      {businessId ? <SeasonsPanel businessId={businessId} /> : null}

      {!businessId ? <p className="text-body text-ink-2">Select a property first.</p> : null}
      {listingsQuery.isLoading ? <PageLoading /> : null}
      {listingsQuery.isError ? <p className="text-body text-danger">Could not load your listings.</p> : null}

      {listingsQuery.data && listingsQuery.data.length > 0 ? (
        <ul className="flex flex-col gap-sm">
          {listingsQuery.data.map((l) => (
            <li key={l.id} className="rounded-card border border-border bg-surface p-md shadow-card">
              <Link
                to="/rates/$listingId"
                params={{ listingId: l.id }}
                className="flex items-center justify-between text-body font-semibold text-canyon underline"
              >
                {l.title}
                <span className="text-caption font-normal text-ink-2">{l.is_active ? 'Published' : 'Draft'}</span>
              </Link>
            </li>
          ))}
        </ul>
      ) : null}

      {listingsQuery.data && listingsQuery.data.length === 0 ? (
        <p className="rounded-card border border-border bg-surface p-lg text-body text-ink-2">
          No listings yet —{' '}
          <Link to="/listings" className="text-canyon underline">
            add one
          </Link>{' '}
          first.
        </p>
      ) : null}
    </section>
  );
}
